import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { fetchExpiredRewards } from "../../redux/slice/offers/expired";

import "./OffersHistory.scss";
import Spinner from "../../component/spinner/Spinner";
import NoDataComp from "../../component/NoDataComp";
import { formatCouponExpiry } from "../../utils/common";
// import gold_rupe_icon_md from "../../assets/images/gold_rupe_md.svg";

const ExpiredRewards = () => {
  const dispatch = useDispatch();
  const { expiredRewardsData, loading } = useSelector(
    (state) => state.expiredReward
  );

  const [rewardsById, setRewardsById] = useState({});
  const [voucherList, setVoucherList] = useState([]);

  // console.log(expiredRewardsData, "expired rewards");
  const logicForMultipleVouchers = (data) => {
    const hash = {};
    const listOfVouchers = [];

    for (let i = 0; i < data.length; i++) {
      hash[data[i].rewardDetails?.rewardId] = data[i].rewardDetails;
      listOfVouchers.push(data[i]?.vouchers);
    }

    // console.log(hash, "hash");
    // console.log(listOfVouchers.flat(1), "listOfVouchers");
    setVoucherList((listOfVouchers && listOfVouchers?.flat(1)) || []);
    setRewardsById(hash);
  };
  useEffect(() => {
    dispatch(fetchExpiredRewards({ status: "expired" }));
    // eslint-disable-next-line 
  }, []);

  useEffect(() => {
    if (expiredRewardsData?.length > 0) {
      logicForMultipleVouchers(expiredRewardsData);
    }
  }, [expiredRewardsData]);
  return (
    <div className="tabTable" style={{maxHeight:'100vh', overflowY:'scroll'}}>
      <div className="border_bottom_section">
        {voucherList?.length > 0 ? 
        voucherList?.map((voucher,index) => (
          <div className="mobile-div" key={index}>
            <p className="mobile_content">
              {formatCouponExpiry(voucher?.issued)
                ? `Expired on ${formatCouponExpiry(voucher?.issued)}`
                : ""}
            </p>
            <div className="d-flex justify-content-between transction_list">
              <div className="hotel_booking_details d-flex align-items-center">
                <img
                  className="hotel_Icon_div"
                  src={rewardsById[voucher?.rewardId]?.imageUrl}
                  alt="puma logo"
                />
                <div className="details-container">
                  <p className="desktop_content">
                    {formatCouponExpiry(voucher?.issued)
                      ? `Expired on ${formatCouponExpiry(voucher?.issued)}`
                      : ""}
                  </p>
                  <h1>{rewardsById[voucher?.rewardId]?.name}</h1>
                  <div className="active-status">
                    <div
                      style={{
                        backgroundColor: `${"#DB4B41"}`,
                      }}
                    ></div>
                    <p
                      style={{
                        color: `${"#DB4B41"}`,
                      }}
                    >
                      {"Expired"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="points_gold">
                <p className="high_light_text">
                  {voucher?.code}
                  {/* <img src={gold_rupe_icon_md} alt="gold coin icon" /> */}
                </p>
              </div>
            </div>
          </div>
        )): (loading ? null :<NoDataComp />)}
        {loading ? (
          <div
            style={{
              height: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner color="black" size="28px" />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ExpiredRewards;
